import { Tab } from '@mui/material';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  // EstadosOrdenTrabajoEnumChoice,
  // ROUTER_PATHS,
  a11yProps,
  useCheckPermissions,
  useTabsFormOnly,
} from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import TableATSComponent from '../../../shared/components/tables/TableATSComponent';

export type DetalleMaterialesTecnicoPageProps = {};

const DetalleMaterialesTecnicoPage: React.FC<
  DetalleMaterialesTecnicoPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);
  // const returnUrlDetalleMaterialesTecnicoPage = ROUTER_PATHS.tecnico.atsNav;
  const { handleMethodChange, valueTab } = useTabsFormOnly();

  return (
    <SingleTableBoxScene title={'Análisis de Trabajo Seguro (ATS)'}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Pendientes" value={1} {...a11yProps(1)} />
          <Tab label="Completadas" value={2} {...a11yProps(2)} />
          <Tab label="Solicitudes de ATS Físico" value={3} {...a11yProps(3)} />
          <Tab label="ATS Físico Aprobados" value={4} {...a11yProps(4)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Asignadas ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <TableATSComponent completado={false}/>
      </CustomTabPanel>

      {/* ============ Asignadas Recoordinadas ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <TableATSComponent completado={true}/>
      </CustomTabPanel>

      {/* ============ Solicitudes de ATS Físico ============ */}
      <CustomTabPanel value={valueTab} index={3}>
        <TableATSComponent completado={true} solicitudesFormatoFisico={true}/>
      </CustomTabPanel>

      {/* ============ ATS Físico Aprobados ============ */}
      <CustomTabPanel value={valueTab} index={4}>
        <TableATSComponent completado={true} solicitudesFormatoFisico={true} apruebaFormatoFisico={true}/>
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default DetalleMaterialesTecnicoPage;
